// Données des employés pour l'évaluation annuelle
export const EMPLOYEES_TO_EVALUATE = [
  {
    id: 147,
    name: "Julien Perez",
    poste: "Développeur backend",
    photo: "JP",
    dossier: {
      points_forts: [
        "Performance technique excellente",
        "Bon sur l'adaptabilité aux nouvelles technologies",
        "Disponibilité solide, respecte les horaires"
      ],
      points_faibles: [
        "Collaboration difficile en équipe",
        "Initiative modeste, propositions souvent rejetées",
        "Alignement faible, questionne les décisions"
      ],
      incidents: [
        "Conflit avec Sofia lors d'une rétro (résolu)",
        "Refus de participer au hackathon corporate"
      ],
      absences: "2 jours (congés)",
    },
    solution: {
      performance: 85,
      collaboration: 30,
      initiative: 55,
      adaptabilite: 75,
      alignement: 30,
      disponibilite: 70
    }
  },
  {
    id: 181,
    name: "Zoé Leroy",
    poste: "Chargée de communication",
    photo: "ZL",
    dossier: {
      points_forts: [
        "Collaboration excellente, très bon esprit d'équipe",
        "Alignement très solide avec la culture",
        "Disponibilité très élevée pour ses collègues"
      ],
      points_faibles: [
        "Performance bonne mais variable",
        "Adaptabilité correcte face aux urgences",
        "Initiative modeste, manque de proactivité"
      ],
      incidents: [
        "Retard sur 2 campagnes ce trimestre"
      ],
      absences: "1 jour (maladie)",
    },
    solution: {
      performance: 60,
      collaboration: 90,
      initiative: 45,
      adaptabilite: 50,
      alignement: 85,
      disponibilite: 95
    }
  },
  {
    id: 194,
    name: "Martin Schmitt",
    poste: "Tech lead frontend",
    photo: "MS",
    dossier: {
      points_forts: [
        "Performance solide en technique",
        "Initiative excellente, force de proposition",
        "Adaptabilité excellente aux nouvelles techno"
      ],
      points_faibles: [
        "Collaboration correcte mais tensions backend",
        "Alignement faible, bouleverse la roadmap",
        "Disponibilité solide mais absences mentales en réunion"
      ],
      incidents: [
        "Conflit avec Julien sur architecture API"
      ],
      absences: "3 jours",
    },
    solution: {
      performance: 75,
      collaboration: 55,
      initiative: 85,
      adaptabilite: 90,
      alignement: 35,
      disponibilite: 70
    }
  }
];

export const ALREADY_EVALUATED = [
  { id: 101, name: "Alexandre Morel", status: "validated" },
  { id: 118, name: "Samir Haddad", status: "validated" },
  { id: 132, name: "Clara Nguyen", status: "validated" },
  { id: 173, name: "Yassine Benkacem", status: "validated" },
  { id: 221, name: "Hugo Bernard", status: "validated" },
  { id: 248, name: "Thomas Dubois", status: "validated" },
  { id: 297, name: "Lucas Fournier", status: "validated" },
  { id: 328, name: "Victor Laurent", status: "validated" },
  { id: 359, name: "Marie Dupont", status: "validated" },
  { id: 389, name: "Camille Henry", status: "validated" },
  { id: 341, name: "Sofia Martins", status: "validated" },
  { id: 286, name: "Nadia El Mansouri", status: "validated" },
  { id: 374, name: "Antoine Leclerc", status: "validated" },
];

export const EXECUTIVES = [
  { id: 272, name: "Olivier Garnier", poste: "Directeur technique" },
  { id: 1, name: "[NOM MASQUÉ]", poste: "CEO" },
  { id: 312, name: "Amira Belkacem", poste: "Directrice juridique" },
];

// Règles d'interdépendance (culture toxique)
export const INTERDEPENDENCIES = {
  performance: {
    affects: "collaboration",
    rule: (perf) => Math.max(0, 100 - perf), // Plus la perf est haute, moins la collab
    tooltip: "Performance élevée = Collaboration réduite"
  },
  initiative: {
    affects: "alignement",
    rule: (init) => Math.max(0, 100 - init), // Plus d'initiatives = moins d'alignement
    tooltip: "Initiative élevée = Alignement culturel faible"
  },
  disponibilite: {
    affects: "adaptabilite",
    rule: (dispo) => Math.max(0, 100 - (dispo * 0.5)), // Trop dispo = moins adaptable (burn-out)
    tooltip: "Disponibilité maximale = Adaptabilité réduite"
  }
};

export const AXES_CONFIG = [
  {
    key: "performance",
    label: "Performance",
    color: "#3b82f6",
    description: "Atteinte des objectifs et qualité du travail"
  },
  {
    key: "collaboration",
    label: "Collaboration",
    color: "#8b5cf6",
    description: "Capacité à travailler en équipe"
  },
  {
    key: "initiative",
    label: "Initiative",
    color: "#10b981",
    description: "Proactivité et force de proposition"
  },
  {
    key: "adaptabilite",
    label: "Adaptabilité",
    color: "#f59e0b",
    description: "Flexibilité face au changement"
  },
  {
    key: "alignement",
    label: "Alignement",
    color: "#ec4899",
    description: "Adhésion à la culture d'entreprise"
  },
  {
    key: "disponibilite",
    label: "Disponibilité",
    color: "#06b6d4",
    description: "Présence et accessibilité"
  }
];